import { Directive, ElementRef, OnDestroy, OnInit, Input } from "@angular/core";

@Directive({
  selector: '[ms-parent-focus]'
})
export class ParentFocusDirective implements OnInit, OnDestroy {
  @Input() alwaysFocusOnRemoval: boolean = false;
  private observer?: MutationObserver;
  
  constructor(private el: ElementRef) {}
  
  ngOnInit() {
    // Make the parent focusable if it isn't already
    if (!this.el.nativeElement.hasAttribute('tabindex')) {
      this.el.nativeElement.setAttribute('tabindex', '0');
    }
    
    // Set up MutationObserver to watch for child removals
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        // Check if any children were removed
        if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
          let shouldFocus = false;
          
          if (this.alwaysFocusOnRemoval) {
            // Focus parent whenever any child is removed
            shouldFocus = true;
          } else {
            // Original behavior: only focus if removed node had focus
            mutation.removedNodes.forEach((removedNode) => {
              if (removedNode === document.activeElement || 
                  (removedNode as Element)?.contains?.(document.activeElement)) {
                shouldFocus = true;
              }
            });
          }
          
          if (shouldFocus) {
            // Use a slightly longer timeout to ensure Angular's change detection is complete
            setTimeout(() => {
              if (document.contains(this.el.nativeElement) && 
                  this.el.nativeElement.tabIndex >= 0) {
                this.el.nativeElement.focus();
              }
            }, 10);
          }
        }
      });
    });
    
    // Start observing
    this.observer.observe(this.el.nativeElement, {
      childList: true,
      subtree: true // Watch all descendants, not just direct children
    });
  }
  
  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
